const namespace = 'bravissimo/password-reset-request';

export const RESET_PASSWORD = `${namespace}/RESET_PASSWORD`;
export const RESET_PASSWORD_SUCCESS = `${namespace}/RESET_PASSWORD_SUCCESS`;
export const RESET_PASSWORD_FAILURE = `${namespace}/RESET_PASSWORD_FAILURE`;
